import { BetAmountInputProps } from './props';
import { useWalletsMe } from '@/api/wallets';
import ErrorLabel from './ErrorLabel';
import BetAmountInputSkeleton from './Skeleton';
import styles from './styles.module.scss';
import BetAmountInputCoin from './Coin';
import { AuthService } from '@/services/AuthService';
// import { BetStatus } from '@/models/bet/status';
import { FormGroup, Input } from '@starsoft/common/components';
import useTranslation from 'next-translate/useTranslation';
import { useBetAmountInput } from '@/hooks/useBetAmountInput';
import { UseBetAmountInputReturn } from '@/hooks/useBetAmountInput/props';
import BetAmountInputButtons from './Buttons';
import { Coin } from '@starsoft/common/models';
import { Either } from '@starsoft/common/interfaces';
import { SettingLayoutComponentId } from '@starsoft/common/models';
import { useBetAmountInputSetting } from '@/hooks/games/useBetAmountInputSetting';
import { BetStatusId } from '@/models/bet/status/id';

export default function BetAmountInput({
  readOnly,
  placeholder,
  bet,
  isError,
  hasExtraButtons,
  isLoading,
}: BetAmountInputProps) {
  const { t } = useTranslation('common');
  const isAuthorized = AuthService.isAuthorized();
  const { wallet } = useWalletsMe();
  const coin: Either<Coin, undefined> = wallet?.currentAccount?.coin;
  const {
    value,
    error,
    onBlur,
    onFocus,
    onChange,
    isTouched,
    isError: isInputError,
  }: UseBetAmountInputReturn = useBetAmountInput({ bet, isError });
  const { version } = useBetAmountInputSetting();

  if (isLoading) {
    return (
      <FormGroup isLoading loading={{ label: true }}>
        <BetAmountInputSkeleton hasExtraButtons={hasExtraButtons} />
      </FormGroup>
    );
  }

  return (
    <div className={styles.container}>
      <FormGroup label={placeholder} className={styles.container}>
        <div
          className={`${styles['container__input-wrapper']} ${+version > SettingLayoutComponentId.BetAmountInputV1 ? styles['container__input-wrapper--default'] : ''}`}
        >
          {version?.toString() ===
            SettingLayoutComponentId.BetAmountInputV4?.toString() && (
            <BetAmountInputCoin bet={bet} />
          )}

          <Input
            className={styles['container__input-wrapper__input']}
            value={value}
            onInput={onChange}
            onBlur={onBlur}
            onFocus={onFocus}
            type="text"
            readOnly={readOnly}
            hideLock
            placeholder="0"
            customIcon={
              version?.toString() !==
                SettingLayoutComponentId.BetAmountInputV4?.toString() && (
                <BetAmountInputCoin bet={bet} />
              )
            }
            isError={isInputError}
            hasPaddingRight={
              version?.toString() ===
              SettingLayoutComponentId.BetAmountInputV1?.toString()
            }
          />
          {hasExtraButtons &&
            +version < SettingLayoutComponentId.BetAmountInputV3 && (
              <BetAmountInputButtons bet={bet} />
            )}
        </div>
      </FormGroup>

      {hasExtraButtons &&
        +version > SettingLayoutComponentId.BetAmountInputV2 && (
          <BetAmountInputButtons bet={bet} />
        )}
      {isAuthorized && !readOnly && (
        <ErrorLabel error={error} open={isTouched} coin={coin ?? null} />
      )}
      {!error &&
        bet?.status?.id?.toString() === BetStatusId.Open?.toString() && (
          <p className={styles.container__description}>
            {t('lock_amount_label')}
          </p>
        )}
    </div>
  );
}
